<template>

    <body style="direction: rtl; text-align: right;">
        <Header pageTitle="منشوراتي" />
        <main>
            <div v-if="loading" class="loading-overlay">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>

            <div v-else>
                <div class="container d-flex flex-column align-items-center justify-content-center">
                    <router-link to="/profile" class="btn mb-3"
                        style="background-color: #b1cedf; color: #000;width: 60%;">
                        عودة للبروفايل
                    </router-link>

                    <div class="row ">
                        <div class="">
                            <div v-if="posts.length > 0">
                                <div v-for="post in posts" :key="post.posts_id">
                                    <PostCard :post="post" :isMyPost="true"/>
                                </div>
                            </div>
                            <div v-else class="text-center mt-4">
                                <p style="color: #296080; font-size: 1.2rem;">لا يوجد منشورات</p>
                            </div>

                            <div v-if="noMorePosts" class="text-center mt-4">
                                <p style="color: #d9534f; font-size: 1.2rem;">لا مزيد من المنشورات</p>
                            </div>

                            <div v-if="isLoadingMore" class="text-center mt-4">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <Footer />
    </body>
</template>


<script>
import Header from '../../components/header.vue'
import Footer from '../../components/footer.vue'
import axios from 'axios';
import PostCard from "../../components/PostCard.vue";

export default {
    name: "MyPosts",
    components: {
        Header,
        Footer,
        PostCard,
    },
    props: {
        msg: String,
    },
    data() {
        return {
            userData: {},
            loading: true,
            ads: [],
            posts: [],
            limit: 3,
            userId: "",
            offset: 0,
            isLoadingMore: false,
            noMorePosts: false,
        };
    },
    mounted() {
        const userId = localStorage.getItem("userId");
        this.userId = userId ? parseInt(userId, 10) : null;
        if (userId) {
            this.fetchUserData(userId);
        } else {
            console.error("User ID غير موجود في Local Storage.");
        }
        console.log(userId);
        this.fetchPosts();
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            const scrollPosition = window.scrollY + window.innerHeight;
            const bottomPosition = document.documentElement.offsetHeight;

            if (scrollPosition >= bottomPosition - 200 && !this.isLoadingMore) {
                this.fetchPosts();
            }
        },
        async fetchUserData(userId) {
            try {
                const response = await axios.post(
                    'https://zadcodeonline.com/ahmad/etqan/backEnd/profiles/view.php',
                    { usersid: userId },
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                if (response.data.status === "success") {
                    this.userData = response.data.data;
                    this.loading = false;
                } else {
                    console.error("فشل في جلب بيانات المستخدم:", response.data);
                }
            } catch (error) {
                console.error("خطأ أثناء جلب بيانات المستخدم:", error);
            }
        },
        async fetchPosts() {
            if (this.isLoadingMore || this.noMorePosts) return;

            this.isLoadingMore = true;
            try {
                const response = await axios.post(
                    'https://zadcodeonline.com/ahmad/etqan/backEnd/profiles/my_post.php',
                    { usersid: this.userId, offset: this.offset, limit: this.limit },
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );

                if (response.data.status === 'success') {
                    // console.log('المنشورات:', response.data.data);
                    const newPosts = response.data.data;

                    if (newPosts.length === 0) {
                        this.noMorePosts = true;
                    } else {
                        const uniquePosts = newPosts.filter(newPost =>
                            !this.posts.some(existingPost => existingPost.posts_id === newPost.posts_id)
                        );

                        this.posts = [...this.posts, ...uniquePosts];
                        this.offset += this.limit;
                    }
                } else {
                    console.error('فشل في جلب المنشورات:', response.data);
                }
            } catch (error) {
                console.error('خطأ أثناء جلب المنشورات:', error);
            } finally {
                this.isLoadingMore = false;
            }
        },
        formatDate(dateStr) {
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            };
            const date = new Date(dateStr);
            return date.toLocaleDateString('ar-EG', options);
        },
    },
};
</script>


<style scoped>
.btn-primary-soft {
    color: #296080;
    border: 1px solid #bbdefb;
}

.btn-primary-soft:hover {
    background-color: #296080;
    color: #fff;
    border: 1px solid #296080;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.post-images-container {
    margin-top: 15px;
}

.single-image img {
    width: 100%;
    height: auto;
}

.two-images img {
    width: 49%;
    /* تقسيم العرض بالتساوي */
    height: auto;
}

.three-or-more-images {
    display: flex;
    flex-wrap: wrap;
}

.three-or-more-images .main-image img {
    width: 100%;
    height: 200px;
    object-fit: cover;
}

.three-or-more-images .other-images img {
    width: 49%;
    /* نصف العرض */
    height: 100px;
    object-fit: cover;
    position: relative;
}

.three-or-more-images .overlay {
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    width: 49%;
    z-index: 1;
}

.carousel-caption h5 {
    font-size: 1.5rem;
    color: #fff;
}

.carousel-caption p {
    font-size: 1rem;
    color: #fff;
}

a {
    color: #296080;
}

.navbar-light .navbar-nav .nav-link {
    color: #ffffff;
}

.card {
    border-radius: 30px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s, box-shadow 0.3s;
    background: linear-gradient(to top, #ffffff, #f8f9fa);
}

.card:hover {
    transform: scale(1.03);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.card-header {
    border-radius: 30px;
}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #296080;
}

.text-itkan {
    font-size: 25px;
    color: #ffffff;
}

.text-person {
    color: #296080;
}

.text-date {
    font-size: 10px;
    color: #2e2e2e;
}

.rounded-card {
    border-radius: 25px;
    overflow: hidden;
}

.carousel-item img {
    border-radius: 30px;
    height: 200px;
    object-fit: cover;
}

@media (max-width: 992px) {
    .carousel-item img {
        border-radius: 30px;
        height: 200px;
        object-fit: cover;
    }

    .row>* {
        margin-top: 10px;
    }
}

@media (max-width: 992px) {
    .navbar-light .navbar-nav .nav-link[data-v-5e4cad4c] {
        color: #296080;
    }

    .navbar>.container,
    .navbar>.container-fluid,
    .navbar>.container-sm,
    .navbar>.container-md,
    .navbar>.container-lg,
    .navbar>.container-xl,
    .navbar>.container-xxl {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: inherit;
        flex-wrap: inherit;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        flex-direction: row-reverse;
    }
}
</style>